import React, { FC, useContext, useRef, useState } from "react";
import styled from "styled-components";
import { CursoPreviewData, EditPreviewProps } from "..";
import { Curso } from "../../../constants/types";
import { useAuthUser } from "../../../Services/useAuthUser";
import { useCoursePreview } from "../hook/useCoursePreview";
import { ElBotton } from "../../../components/common/ElBotton";
import { useUploadFile } from "../hook/useUploadFile";

const Container = styled.div`
  display: flex;
  margin: 0 auto;
  margin-bottom: 78px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  align-items: center;

  div {
    width: 50%;
  }

  img {
    max-width: 100%;
  }

  h3 {
    font-family: "Montserrat";
    font-weight: 700;
    font-size: 22px;
    margin-bottom: 30px;
    text-align: center;
  }

  ul {
    padding: 0 0 0 8px;
    list-style-type: none;

    li {
      font-family: "Montserrat";
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 1.1rem;
      position: relative;
      overflow: hidden;
      height: auto;

      .modify-delete-buttons {
        right: 0;
      }

      p {
        margin: 0;
        font-family: "Montserrat";
        font-weight: 400;
        font-size: 16px;
        line-height: 16px;
        margin-left: 7px;
      }

      .add-beneficio-label {
        text-align: center;
        width: 100%;
        color: #145882;
        font-weight: 700;
        line-height: normal;
        cursor: pointer;
      }
    }
  }
`;
type CursoGoalsProps = {
  cursoTipo: string;
  cursoBeneficios: string[];
  courseData: Curso;
};
const CursoGoals: FC<CursoGoalsProps> = ({
  cursoTipo,
  cursoBeneficios,
  courseData,
}) => {
  const { isAdmin } = useAuthUser();

  const uploadFile = useUploadFile();
  const { addCoursePreviewData } = useCoursePreview();
  const EditData = useContext(EditPreviewProps);

  async function uploadfile() {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*";
    fileInput.onchange = async (event: any) => {
      const url = await uploadFile(event.target.files[0], courseData.id);
      const resolve = await addCoursePreviewData(courseData.id, {
        previewBeneficioImagen: url,
      });
      window.alert(resolve);
      EditData.update();
    };
    fileInput.click();
  }

  return (
    <Container>
      {(isAdmin || courseData.previewBeneficioImagen) && (
        <div>
          <img
            src={courseData.previewBeneficioImagen}
            alt="imagen promocional"
          />
          {isAdmin && <ElBotton onClick={uploadfile}>Subir imagen</ElBotton>}
        </div>
      )}

      <div>
        <h3>Con este {cursoTipo} vas a lograr:</h3>
        <ul>
          {cursoBeneficios.map((beneficio, index) => (
            <BeneficioElement text={beneficio} key={index} />
          ))}
          {isAdmin && <AddBeneficio />}
        </ul>
      </div>
    </Container>
  );
};

const ModifyDeleteContainer = styled.span`
  transition: 0.5s;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  padding: 0 5px;
  align-items: center;
  justify-content: center;
  right: -58px;

  i {
    margin: 0 5px;
    color: gray;
    cursor: pointer;

    :first-of-type:hover {
      color: #618af17d;
    }
    :last-of-type:hover {
      color: crimson;
    }
  }
`;
type BeneficioElementProps = {
  text: string;
};
const BeneficioElement: FC<BeneficioElementProps> = ({ text }) => {
  const [isModifyModule, setModifyModule] = useState(false);
  const { addCoursePreviewData } = useCoursePreview();
  const cursoData = useContext(CursoPreviewData);
  const EditData = useContext(EditPreviewProps);
  const inputReference = useRef<any>(null);

  function enableModification(event: any) {
    if (event.target !== inputReference.current) {
      setModifyModule(!isModifyModule);
    }
  }

  function onLoseFocus() {
    setModifyModule(false);
  }

  function renameBeneficio(event: any) {
    if (event.key === "Enter" && cursoData?.previewBeneficios) {
      let nuevosBeneficios = cursoData.previewBeneficios;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      nuevosBeneficios[nuevosBeneficios.indexOf(text)] = event.target.value;

      addCoursePreviewData(cursoData.id, {
        previewBeneficios: nuevosBeneficios,
      })
        .then((resolve) => {
          EditData.update();
        })
        .catch((reject) => {
          window.alert(reject);
        });

      setModifyModule(false);
    }
  }

  function deleteLesson() {
    if (cursoData?.previewBeneficios) {
      let nuevosBeneficios = cursoData.previewBeneficios;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      nuevosBeneficios = nuevosBeneficios.filter(
        (beneficio) => beneficio !== text
      );

      addCoursePreviewData(cursoData.id, {
        previewBeneficios: nuevosBeneficios,
      })
        .then((resolve) => {
          console.log(resolve);
          EditData.update();
        })
        .catch((reject) => {
          window.alert(reject);
        });
    }
  }

  return (
    <li>
      {isModifyModule ? (
        <>
          {checkoutIcon}
          <InputContainer style={{ marginBottom: "max(8px,2%)" }}>
            <input
              autoFocus
              ref={inputReference}
              onBlur={onLoseFocus}
              onKeyPress={renameBeneficio}
            />
          </InputContainer>
        </>
      ) : (
        <>
          {checkoutIcon}
          <p>{text}</p>
          {EditData.isAdmin && (
            <ModifyDeleteContainer className="modify-delete-buttons">
              <i className="fas fa-pen-square" onClick={enableModification}></i>
              <i className="fas fa-trash-alt" onClick={deleteLesson}></i>
            </ModifyDeleteContainer>
          )}
        </>
      )}
    </li>
  );
};

const InputContainer = styled.div`
  border-radius: 5px;
  width: 100%;
  margin-left: -1px;
  padding: 1px 8px 1px;
  height: inherit;

  input {
    margin-top: 2px;
    height: 100%;
    outline-width: 0;
    border: none;
    width: 100%;
    background: none;

    font-family: "Montserrat";
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    color: black;
  }

  input:focus {
    height: 100%;
    outline-width: 0;
    border: none;
  }
`;

const AddBeneficio = () => {
  const [isModifyModule, setModifyModule] = useState(false);
  const { addCoursePreviewData } = useCoursePreview();
  const cursoData = useContext(CursoPreviewData);
  const EditData = useContext(EditPreviewProps);
  const inputReference = useRef<any>(null);

  function enableModification(event: any) {
    if (event.target !== inputReference.current) {
      setModifyModule(!isModifyModule);
    }
  }

  function onLoseFocus() {
    setModifyModule(false);
  }

  function createBeneficio(e: any) {
    if (e.key === "Enter" && cursoData?.previewBeneficios) {
      let nuevosBeneficios = cursoData.previewBeneficios;
      nuevosBeneficios.push(e.target.value);

      addCoursePreviewData(cursoData.id, {
        previewBeneficios: nuevosBeneficios,
      })
        .then((resolve) => {
          EditData.update();
        })
        .catch((reject) => {
          window.alert(reject);
        });

      setModifyModule(false);
    }
  }

  return (
    <li onClick={enableModification}>
      {isModifyModule ? (
        <>
          {checkoutIcon}
          <InputContainer style={{ marginBottom: "max(8px,2%)" }}>
            <input
              autoFocus
              ref={inputReference}
              onBlur={onLoseFocus}
              onKeyPress={createBeneficio}
            />
          </InputContainer>
        </>
      ) : (
        <p className="add-beneficio-label">Agregar nuevo Beneficio</p>
      )}
    </li>
  );
};

const checkoutIcon = (
  <svg
    width="25"
    height="23"
    viewBox="0 0 25 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g style={{ clipPath: "url(#clip0_54_428)" }}>
      <path
        d="M13.2716 6.77397C13.4259 6.61644 13.5802 6.4589 13.7346 6.30137C13.8889 6.4589 14.0432 6.61644 14.1975 6.77397C14.1975 6.77397 14.1975 6.77397 14.3519 6.77397C14.5062 6.61644 14.5062 6.61644 14.5062 6.4589C14.5062 6.30137 14.5062 6.30137 14.6605 6.30137C14.8148 6.30137 14.8148 6.30137 14.9691 6.14384C14.9691 6.14384 15.1235 6.14384 14.9691 5.9863H14.8148C14.8148 5.9863 14.6605 6.14384 14.6605 5.9863V5.82877C14.6605 5.82877 14.8148 5.82877 14.6605 5.67123L14.5062 5.5137C14.3519 5.5137 14.1975 5.67123 14.1975 5.82877V5.9863C14.1975 6.30137 14.0432 6.14384 14.0432 6.30137C13.8889 6.30137 13.8889 6.30137 13.7346 6.14384C14.5062 5.5137 15.1235 4.72603 15.8951 4.09589V4.25342H15.7407C15.7407 4.41096 15.7407 4.41096 15.7407 4.56849C15.5864 4.72603 15.5864 4.72603 15.4321 4.88356C15.4321 5.0411 15.4321 5.19863 15.4321 5.19863C15.5864 5.35616 15.5864 5.35616 15.7407 5.19863C15.8951 5.0411 15.8951 4.88356 15.7407 4.72603C15.8951 4.88356 16.0494 4.88356 16.0494 4.72603C16.0494 4.72603 16.2037 4.56849 16.0494 4.56849C16.0494 4.41096 15.8951 4.56849 15.8951 4.56849H15.7407V4.41096V4.25342C15.8951 4.25342 15.8951 4.41096 16.0494 4.41096H16.2037C16.2037 4.41096 16.2037 4.41096 16.2037 4.25342C16.2037 4.25342 16.2037 4.25342 16.2037 4.09589H16.358C16.358 4.09589 16.5123 4.09589 16.5123 3.93836C16.5123 3.78082 16.358 3.93836 16.358 3.93836C16.2037 3.93836 16.2037 3.93836 16.2037 3.78082V3.62329C16.2037 3.62329 16.0494 3.62329 16.2037 3.78082C16.2037 3.78082 16.2037 3.78082 16.2037 3.93836L16.0494 3.78082C16.2037 3.62329 16.2037 3.62329 16.358 3.62329C18.3642 2.04795 20.5247 0.787671 22.8395 0.157534C23.6111 0.157534 24.2284 0 25 0C21.6049 1.89041 18.6728 4.56849 16.358 7.71918C14.9691 9.60959 13.7346 11.6575 12.6543 13.7055C12.6543 13.863 12.5 14.1781 12.3457 14.3356C12.1914 14.1781 12.1914 14.1781 12.037 14.0205C12.037 14.0205 12.037 14.0205 11.8827 14.0205C11.8827 14.0205 11.8827 14.0205 11.8827 14.1781C11.8827 14.1781 12.037 14.3356 11.8827 14.3356C11.7284 14.4932 11.8827 14.6507 11.8827 14.8082C11.8827 14.6507 11.7284 14.6507 11.5741 14.4931H11.4198V14.6507C11.5741 14.8082 11.5741 14.9658 11.7284 15.1233C11.7284 15.1233 11.7284 15.2808 11.8827 15.1233C11.8827 15.1233 11.8827 15.1233 11.8827 14.9658V14.8082C11.8827 14.8082 11.8827 14.6507 12.037 14.6507H12.1914C11.4198 16.226 10.8025 17.3288 10.3395 18.589C9.72222 19.5342 9.25926 20.4795 8.64197 21.4247C8.17901 22.0548 7.71605 22.5274 7.09876 23C6.94444 23 6.94444 23 6.79012 23C6.17284 22.5274 5.8642 21.8973 5.55555 21.2671C5.09259 20.3219 4.78395 19.2192 4.47531 18.274C4.16667 17.3288 3.85802 16.3836 3.39506 15.5959C3.08642 14.9658 2.62346 14.3356 1.85185 14.0205C1.85185 13.863 1.69753 13.7055 1.54321 13.7055C1.69753 13.5479 1.85185 13.3904 1.69753 13.2329C1.85185 13.2329 2.00617 13.2329 2.00617 13.2329C2.00617 13.2329 2.16049 13.0753 2.00617 13.0753H1.85185C1.85185 13.0753 1.85185 13.0753 1.69753 13.0753C1.69753 13.0753 1.69753 13.0753 1.69753 12.9178C1.69753 12.9178 1.85185 12.7603 1.69753 12.7603C1.54321 12.7603 1.54321 12.7603 1.38889 12.7603C1.23457 12.9178 1.38889 13.0753 1.38889 13.0753C1.23457 13.0753 1.23457 12.9178 1.08025 13.0753H0.925926H0.771605V13.2329C0.925926 13.3904 0.925926 13.3904 1.08025 13.5479C1.08025 13.5479 1.23457 13.5479 1.08025 13.7055C0.925926 13.5479 0.462963 13.3904 0 13.5479C0.462963 12.1301 1.54321 11.0274 3.08642 11.3425C3.08642 11.5 3.08642 11.5 3.08642 11.6575C3.08642 11.6575 3.08642 11.8151 2.9321 11.8151C2.77778 11.8151 2.62346 11.9726 2.62346 11.9726C2.62346 12.1301 2.62346 12.2877 2.77778 12.2877C2.9321 12.2877 3.08642 12.2877 3.08642 12.1301C3.08642 11.9726 3.24074 11.8151 3.39506 11.8151C3.39506 11.8151 3.54938 11.8151 3.54938 11.6575H3.39506C3.24074 11.6575 3.24074 11.6575 3.24074 11.6575C3.24074 11.6575 3.24074 11.5 3.39506 11.5C4.01235 11.5 4.62963 11.8151 5.09259 12.1301C6.32716 13.2329 7.09877 14.6507 7.40741 16.3836C7.40741 16.3836 7.40741 16.226 7.56173 16.226C8.7963 13.0753 10.4938 10.2397 12.5 7.56164C12.5 7.56164 12.5 7.56164 12.6543 7.40411C12.8086 7.71918 12.8086 7.87671 12.8086 8.03425C12.8086 8.03425 12.8086 8.19178 12.963 8.19178V8.03425C12.963 7.87671 12.963 7.87671 13.1173 7.87671H13.2716C13.2716 7.71918 13.2716 7.87671 13.1173 7.71918C13.1173 7.56164 12.8086 7.56164 12.8086 7.40411C12.963 7.24657 12.963 7.08904 13.1173 7.08904C13.2716 7.08904 13.2716 7.08904 13.2716 7.24657C13.1173 7.40411 13.2716 7.56164 13.4259 7.71918C13.5802 7.71918 13.7346 7.71918 13.7346 7.56164C13.7346 7.40411 13.7346 7.40411 13.7346 7.40411C13.4259 7.08904 13.2716 6.93151 13.2716 6.77397ZM4.62963 16.226C4.47531 16.0685 4.32099 16.0685 4.32099 16.226C4.16667 16.3836 4.16667 16.3836 4.32099 16.5411C4.32099 16.6986 4.47531 16.6986 4.62963 16.6986C4.78395 16.5411 4.78395 16.5411 4.62963 16.226C4.78395 16.226 4.93827 16.226 4.93827 16.226C4.93827 16.226 5.09259 16.226 5.09259 16.0685C5.09259 15.911 4.93827 16.0685 4.93827 16.0685C4.93827 16.0685 4.93827 16.0685 4.62963 16.226C4.78395 16.0685 4.78395 15.911 4.78395 15.911C4.78395 15.911 4.93827 15.911 4.78395 15.7534H4.62963C4.62963 15.911 4.62963 16.0685 4.62963 16.226ZM7.71605 19.2192C7.87037 19.2192 8.02469 19.2192 8.02469 19.0616C8.02469 19.0616 8.17901 19.0616 8.02469 18.9041H7.87037C7.87037 18.9041 7.87037 19.0616 7.71605 18.9041V18.7466C7.71605 18.7466 7.87037 18.589 7.71605 18.589L7.56173 18.4315C7.40741 18.4315 7.25309 18.589 7.40741 18.7466C7.56173 19.0616 7.56173 19.0616 7.71605 19.2192C7.56173 19.0616 7.40741 19.0616 7.25309 19.0616H7.09876H6.94444V19.2192C7.09876 19.3767 7.09876 19.3767 7.25309 19.5342H7.40741C7.71605 19.5342 7.71605 19.3767 7.71605 19.2192ZM9.10494 17.6438C9.25926 17.6438 9.41358 17.6438 9.41358 17.6438C9.41358 17.6438 9.5679 17.6438 9.41358 17.4863H9.25926H9.10494V17.3288V17.1712H8.95062L8.7963 17.3288C8.7963 17.4863 8.7963 17.4863 8.64197 17.4863C8.48765 17.4863 8.48765 17.4863 8.33333 17.6438C8.33333 17.8014 8.33333 17.9589 8.48765 17.9589C8.64197 17.9589 8.64197 17.9589 8.7963 17.9589C9.25926 17.9589 9.10494 17.8014 9.10494 17.6438ZM6.6358 20.4795C6.79012 20.4795 6.94444 20.3219 6.94444 20.1644C6.79012 20.0068 6.6358 19.8493 6.48148 19.6918C6.48148 19.6918 6.48148 19.6918 6.32716 19.6918C6.32716 19.6918 6.32716 19.6918 6.32716 19.8493C6.48148 20.0068 6.32716 20.0068 6.32716 20.1644C6.32716 20.3219 6.48148 20.4795 6.6358 20.4795ZM6.48148 20.637C6.48148 20.637 6.6358 20.637 6.48148 20.637C6.6358 20.4795 6.48148 20.4795 6.48148 20.637C6.32716 20.4795 6.17284 20.3219 6.17284 20.3219H6.01852V20.4795C6.01852 20.637 6.17284 20.7945 6.17284 20.9521C6.17284 20.9521 6.17284 21.1096 6.17284 20.9521C6.17284 20.9521 6.17284 20.9521 6.17284 20.7945C6.17284 20.637 6.32716 20.637 6.48148 20.637Z"
        fill="#145882"
      />
      <path
        d="M13.7344 6.14386C13.8887 6.3014 13.8887 6.3014 14.043 6.3014C14.1973 6.3014 14.1973 6.3014 14.3517 6.3014C14.3517 6.14386 14.3517 6.14386 14.3517 6.14386C14.3517 5.98633 14.506 5.8288 14.6603 5.8288C14.6603 5.8288 14.8146 5.8288 14.8146 5.98633V6.14386C14.8146 6.14386 14.6603 6.14386 14.8146 6.3014H14.9689C14.9689 6.3014 14.9689 6.14386 15.1233 6.3014V6.45893C15.1233 6.45893 14.9689 6.61647 14.8146 6.61647C14.6603 6.61647 14.6603 6.61647 14.6603 6.774C14.6603 6.93154 14.6603 6.93154 14.506 7.08907C14.506 7.08907 14.506 7.08907 14.3517 7.08907C14.043 6.61647 13.7344 6.45893 13.7344 6.14386C13.7344 6.3014 13.7344 6.3014 13.7344 6.14386Z"
        fill="#145882"
      />
      <path
        d="M12.0372 14.9658C11.8829 14.9658 11.8829 14.9658 11.8829 14.9658C11.8829 14.9658 11.8829 14.9658 11.8829 15.1233V15.2808C11.8829 15.2808 11.8829 15.2808 11.7286 15.2808C11.5742 15.1233 11.5742 14.9658 11.4199 14.8082V14.6507H11.5742C11.7286 14.8082 11.8829 14.8082 12.0372 14.8082C11.8829 14.6507 11.8829 14.4932 12.0372 14.3356V14.1781V14.0206C12.0372 14.0206 12.0372 14.0206 12.1915 14.0206C12.1915 14.1781 12.1915 14.1781 12.3458 14.3356C12.1915 14.4932 12.1915 14.8082 12.0372 14.9658Z"
        fill="#145882"
      />
      <path
        d="M3.39514 11.3425C3.24082 11.3425 3.24082 11.5 3.24082 11.5C3.24082 11.6575 3.39514 11.6575 3.39514 11.5H3.54946C3.54946 11.5 3.54946 11.6575 3.39514 11.6575C3.0865 11.6575 3.0865 11.8151 3.0865 11.9726C3.0865 12.1301 2.93218 12.1301 2.77786 12.1301C2.62354 12.1301 2.62354 11.9726 2.62354 11.8151C2.62354 11.6575 2.77786 11.5 2.93218 11.6575C3.0865 11.5 3.0865 11.5 3.0865 11.5C3.0865 11.3425 3.24082 11.3425 3.0865 11.1849C3.24082 11.1849 3.39514 11.1849 3.39514 11.3425Z"
        fill="#145882"
      />
      <path
        d="M1.38872 13.7055C1.38872 13.5479 1.38872 13.5479 1.38872 13.7055C1.2344 13.3904 1.2344 13.3904 1.08008 13.2329V13.0753H1.2344H1.38872C1.54304 12.9178 1.54304 13.0753 1.69736 13.0753C1.85168 13.2329 1.69736 13.3904 1.54304 13.5479C1.54304 13.7055 1.38872 13.7055 1.38872 13.7055Z"
        fill="#145882"
      />
      <path
        d="M13.2715 6.77399C13.4259 6.93152 13.5802 7.08905 13.5802 7.08905C13.5802 7.08905 13.7345 7.24659 13.5802 7.24659C13.5802 7.56166 13.4259 7.56166 13.2715 7.56166C13.1172 7.56166 12.9629 7.24659 13.1172 7.08905C13.2715 6.93152 13.1172 6.93152 12.9629 6.93152C13.1172 6.93152 13.1172 6.93152 13.2715 6.77399Z"
        fill="#145882"
      />
      <path
        d="M12.8086 7.40411C12.963 7.56165 13.1173 7.56165 13.2716 7.71918C13.2716 7.71918 13.4259 7.71918 13.4259 7.87672H13.2716C13.1173 7.71918 12.963 7.87672 12.963 7.87672V8.03425C12.8086 8.03425 12.8086 8.03425 12.8086 7.87672C12.8086 7.71918 12.6543 7.56165 12.5 7.40411C12.6543 7.40411 12.6543 7.40411 12.8086 7.40411Z"
        fill="#145882"
      />
      <path
        d="M16.0493 4.41095V4.25342L16.2036 4.41095C16.2036 4.41095 16.2036 4.41096 16.2036 4.25342V4.09589C16.358 4.09589 16.2036 4.09589 16.2036 4.25342C16.2036 4.41096 16.2036 4.41095 16.358 4.41095H16.5123C16.5123 4.56849 16.5123 4.56849 16.358 4.56849H16.2036C16.2036 4.56849 16.2036 4.56849 16.2036 4.72602C16.2036 4.72602 16.2036 4.72602 16.2036 4.88356H16.0493C16.2036 4.56849 16.2036 4.41095 16.0493 4.41095Z"
        fill="#145882"
      />
      <path
        d="M16.0494 4.41095C16.0494 4.56848 15.8951 4.72602 16.0494 4.72602H16.2037C16.2037 4.72602 16.2037 4.56848 16.3581 4.72602V4.88355C16.2037 5.04109 16.2037 4.88355 16.0494 4.88355C16.2037 5.04109 16.2037 5.19862 16.0494 5.35616C15.8951 5.35616 15.8951 5.35616 15.7408 5.35616C15.4321 5.04109 15.4321 5.04109 15.4321 4.88355C15.5864 4.72602 15.5864 4.72602 15.7408 4.72602C15.7408 4.56848 15.7408 4.56848 16.0494 4.41095C15.8951 4.41095 15.8951 4.41095 16.0494 4.41095Z"
        fill="#145882"
      />
      <path
        d="M9.10505 17.6438C9.10505 17.8013 9.10505 17.9589 9.10505 17.9589C8.95073 17.9589 8.95073 17.9589 8.79641 17.9589C8.64209 17.8013 8.64209 17.8013 8.64209 17.6438C8.64209 17.4863 8.79641 17.4863 8.95073 17.4863C9.10505 17.4863 9.10505 17.4863 9.10505 17.3287C9.10505 17.1712 9.10505 17.1712 9.25937 17.1712C9.25937 17.1712 9.25937 17.1712 9.4137 17.1712C9.4137 17.1712 9.4137 17.1712 9.4137 17.3287C9.4137 17.3287 9.25937 17.4863 9.4137 17.4863C9.4137 17.6438 9.56802 17.4863 9.56802 17.4863H9.72234C9.72234 17.4863 9.72234 17.4863 9.72234 17.6438C9.4137 17.8013 9.25937 17.6438 9.10505 17.6438Z"
        fill="#145882"
      />
      <path
        d="M7.71592 19.2192C7.71592 19.3767 7.71592 19.5342 7.5616 19.6918H7.40728C7.25295 19.5342 7.25295 19.5342 7.09863 19.3767V19.2192H7.25295H7.40728C7.40728 19.0616 7.40728 19.0616 7.71592 19.2192C7.5616 19.2192 7.5616 19.2192 7.71592 19.2192Z"
        fill="#145882"
      />
      <path
        d="M6.63579 20.4794C6.48147 20.4794 6.32715 20.3219 6.32715 20.1644C6.32715 20.0068 6.48147 20.0068 6.32715 19.8493C6.32715 19.8493 6.32715 19.8493 6.32715 19.6918C6.32715 19.6918 6.32715 19.6918 6.48147 19.6918C6.63579 19.8493 6.79011 20.0068 6.94443 20.1644C6.94443 20.1644 6.94443 20.3219 6.63579 20.4794Z"
        fill="#145882"
      />
      <path
        d="M6.48149 20.637C6.32717 20.637 6.17285 20.637 6.32717 20.7945V20.952C6.32717 20.7945 6.17285 20.637 6.17285 20.4794V20.3219H6.32717C6.17285 20.3219 6.32717 20.4794 6.48149 20.637C6.48149 20.4794 6.63581 20.4794 6.48149 20.637C6.63581 20.637 6.48149 20.637 6.48149 20.637Z"
        fill="#145882"
      />
      <path
        d="M4.78399 16.226C4.78399 16.5411 4.78399 16.5411 4.62967 16.6986C4.47535 16.6986 4.32103 16.6986 4.32103 16.5411C4.16671 16.3835 4.32103 16.226 4.32103 16.226C4.47535 16.0685 4.47535 16.0685 4.78399 16.226C4.62967 16.226 4.62967 16.226 4.78399 16.226C4.62967 16.226 4.78399 16.226 4.78399 16.226Z"
        fill="#145882"
      />
      <path
        d="M1.69749 13.2329C1.69749 13.0753 1.54317 12.9178 1.69749 12.7603C1.85181 12.7603 1.85181 12.6027 2.00614 12.7603C2.16046 12.9178 2.00614 12.9178 2.00614 12.9178C2.00614 12.9178 2.00614 12.9178 2.00614 13.0753C2.00614 13.0753 2.00614 13.0753 2.16046 13.0753C2.16046 13.0753 2.31478 12.9178 2.31478 13.0753V13.2329C2.00614 13.2329 1.85181 13.2329 1.69749 13.2329Z"
        fill="#145882"
      />
      <path
        d="M7.71584 19.2192C7.56152 19.2192 7.56152 19.2192 7.71584 19.2192C7.56152 19.0617 7.56152 19.0617 7.56152 19.0617C7.56152 18.9041 7.56152 18.7466 7.71584 18.7466C7.71584 18.7466 7.87016 18.7466 7.87016 18.9041V19.0617C7.87016 19.0617 7.71584 19.2192 7.87016 19.2192C7.87016 19.2192 7.87016 19.2192 8.02449 19.2192C8.02449 19.2192 8.17881 19.0617 8.17881 19.2192V19.3767C7.87017 19.2192 7.87017 19.2192 7.71584 19.2192Z"
        fill="#145882"
      />
      <path
        d="M4.78372 16.226C4.78372 16.226 4.62939 16.226 4.78372 16.226C4.62939 16.0685 4.62939 15.911 4.62939 15.7534C4.62939 15.7534 4.78372 15.5959 4.78372 15.7534V15.911C4.78372 15.911 4.78372 15.911 4.78372 16.226C4.93804 16.0685 4.93804 16.0685 5.09236 16.0685C5.09236 16.0685 5.24668 15.911 5.24668 16.0685C5.24668 16.0685 5.24668 16.226 5.09236 16.226C4.93804 16.226 4.78372 16.226 4.78372 16.226Z"
        fill="#145882"
      />
    </g>
    <defs>
      <clipPath id="clip0_54_428">
        <rect width="25" height="23" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CursoGoals;
